<template>
  <template
    v-for="(section, index) in sections"
    :key="section"
  >
    <slot
      :name="`divider_${index}`"
      v-bind="{ section }"
    />
  </template>
</template>
<script setup lang="ts">

const props = defineProps({
  collection: {
    type: Array,
    default: () => [],
    required: false
  },
  position: {
    type: Number,
    default: 1000,
    required: false
  },
  lazyLoadPosition: {
    type: Number,
    default: 0,
    required: false
  }
});

const adConfig = inject('adConfig', null);
const bannerConfig = inject('bannerConfig', null);
const slotConfig = inject('slotConfig', ref(null));

const sections = computed(() => {
  const { items: splitItems, feed, toplists } = useEditorsToplistCutoff().splitAtCutoff(props.collection || []);

  toplists.forEach((toplist) => {
    toplist.fields.items = feed;
  });

  if (props.position <= 0) {
    const { sectionOne: processedSectionOne, topSlots, bottomSlots } = processSectionsWithSlotInjection(splitItems || [], []);

    slotConfig.value = processSlotConfig(adConfig, bannerConfig, topSlots, bottomSlots);

    return [processedSectionOne];
  }

  const updatedCollectionWithLazyLoad = splitItems.map((item, index) =>
    index < props.lazyLoadPosition ? updateSections(item) : item
  );

  const filteredItems = updatedCollectionWithLazyLoad.filter((group) => {
    return !(group.type === 'group' && group.items?.[0]?.items?.length === 0);
  });

  const [sectionOne, sectionTwo] = [filteredItems?.slice(0, props.position), filteredItems?.slice(props.position)];

  const { sectionOne: processedSectionOne, sectionTwo: processedSectionTwo, topSlots, bottomSlots } = processSectionsWithSlotInjection(sectionOne || [], sectionTwo || []);

  slotConfig.value = processSlotConfig(adConfig, bannerConfig, topSlots, bottomSlots);

  return filteredItems.length > props.position ? [processedSectionOne, processedSectionTwo] : [processedSectionOne];
});

const updateSections = (data) => {
  if (data.type === 'group') {
    return {
      ...data,
      items: data.items.map(updateSections)
    };
  }

  return {
    ...data,
    items: data.items.map((item) => {
      if (item.type === 'cpp-placeholder') {
        return {
          ...item,
          fields: {
            ...item.fields,
            loadingMode: 'eager'
          }
        };
      }
      return {
        ...item,
        loadingMode: 'eager'
      };
    })
  };
};

</script>
